import { useEffect, useState } from 'react';
import { SearchInput } from '@/components/ui/search-input';
import { useDebouncedValue } from '@/hooks/useDebouncedValue';

interface InvoiceFiltersProps {
  searchQuery: string;
  onSearchQueryChange: (query: string) => void;
}

export function InvoiceFilters({
  searchQuery,
  onSearchQueryChange,
}: InvoiceFiltersProps) {
  // Local input state debounced before notifying the parent, which refetches
  // from the server on every searchQuery change.
  const [localQuery, setLocalQuery] = useState(searchQuery);
  const debouncedQuery = useDebouncedValue(localQuery, 300);

  useEffect(() => {
    if (debouncedQuery !== searchQuery) {
      onSearchQueryChange(debouncedQuery);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [debouncedQuery]);

  return (
    <div className="flex flex-col lg:flex-row gap-4">
      <div className="flex-1">
        <SearchInput
          placeholder="Search by invoice number, client, matter..."
          value={localQuery}
          onChange={setLocalQuery}
        />
      </div>
    </div>
  );
}
